import { t } from "i18next";
import { paths } from "src/routes/paths";
import { ICONS } from "..";

const baseAdminItems = [
    {
        title: t("Agencies"),
        path: paths.dashboard.admin.agencies,
        icon: ICONS.booking,
    },
    {
        title: t("Users"),
        path: paths.dashboard.user.list,
        icon: ICONS.booking,
    },
];

const superAdminItems = [
    {
        title: t("Super Admin"),
        path: paths.dashboard.admin.salesreport,
        icon: ICONS.folder,
        children: [
            {
                title: t("Agencies"),
                path: paths.dashboard.admin.agencies,
            },
            {
                title: t("Bookings"),
                path: paths.dashboard.admin.bookings,
            },
            {
                title: t("Reports"),
                path: paths.dashboard.admin.salesreport,
                children: [
                    {
                        title: t("Sales"),
                        path: paths.dashboard.admin.salesreport,
                    },
                    {
                        title: t("Businesses"),
                        path: paths.dashboard.admin.clientsreport,
                    },
                ],
            },
        ],
    },
];

export { baseAdminItems, superAdminItems };
